export default "__VITE_ASSET__e2ae87aa__"